import { useEffect, useState } from "react"

import { useToastStore, type ToastData } from "@/stores/toast-store"
import { ErrorToast } from "./error-toast"

const AUTO_MS = 4000

/** App-level toast outlet: animates in at the top, removed instantly on dismiss. */
export function Toaster() {
  const hide = useToastStore((s) => s.hide)
  const [shown, setShown] = useState<ToastData | null>(null)

  useEffect(() => {
    let autoTimer: ReturnType<typeof setTimeout>
    const unsubscribe = useToastStore.subscribe((state) => {
      clearTimeout(autoTimer)
      setShown(state.toast)
      if (state.toast) {
        autoTimer = setTimeout(() => useToastStore.getState().hide(), AUTO_MS)
      }
    })
    return () => {
      clearTimeout(autoTimer)
      unsubscribe()
    }
  }, [])

  if (!shown) return null

  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[1250] flex justify-center px-4 pt-4"
      style={{ fontFamily: '"Red Hat Text Variable", sans-serif' }}
    >
      <button
        type="button"
        onClick={hide}
        aria-label="Dismiss"
        className="pointer-events-auto w-full max-w-app text-left animate-in fade-in slide-in-from-top duration-200 ease-out"
      >
        <ErrorToast title={shown.title} subtitle={shown.subtitle} />
      </button>
    </div>
  )
}
